<template>
  <div id="organization">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>快速审批</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="tabsActive">
        <!-- 快速审批 -->
        <el-tab-pane label="快速审批" name="1">
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="list"
            stripe
            height="calc(100%  - 20px - 50px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column
              prop="company_name"
              :show-overflow-tooltip="true"
              align="center"
              label="项目名称"
            ></el-table-column>

            <el-table-column
              prop="pte_type_show"
              :show-overflow-tooltip="true"
              align="center"
              label="评价类型"
            ></el-table-column>
            <el-table-column
              prop="department_name"
              :show-overflow-tooltip="true"
              align="center"
              label="用户名"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.userInfo">{{scope.row.userInfo.nickname}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="address" width="300" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleRemoveSql(scope.row)"
                  class="tableBtn"
                  style="    border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pageRow" v-if="list.length>0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              background
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      Total: 0,
      tabsActive: '1',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      list: [],
    }
  },
  methods: {
    // *获取我的自动审批
    async getList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/User/my_sql',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.list = res.datas.list
      console.log('首页信息', this.indexInfo)
    },
    async handleRemoveSql(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('sql_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/User/my_sql_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getList()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
  },
  activated() {
    console.log('activated')
    this.getList()
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getList()
  },
}
</script>
<style lang="less" scoped>
#organization {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      /deep/.tableSearch {
        width: 28%;
        // (deep)
        .el-input__inner {
          height: 45px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
      }
    }
    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        // font-size: 18px;
        font-size: inherit;
      }
    }
    .el-input__inner {
      // font-size: 18px;
      font-size: inherit;
      width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-cascader {
      width: 80%;
      .el-input {
        width: 100%;
      }
      .el-input__inner {
        width: 100%;
        font-size: inherit;
      }
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        // font-size: 18px;
        font-family: Microsoft YaHei;
        font-size: inherit;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        // font-size: 18px;
        font-size: inherit;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  /deep/.heder40 {
    height: 56px;
  }
}
/deep/.ql-container {
  font-size: inherit;
}
.yauto {
  height: 40vh;
  overflow-y: auto;
}
.yauto2 {
  height: 60vh;
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: rgba(0, 0, 0, 0.5);
}

.ql-container {
  width: 95%;
  height: initial;
}
/deep/.v-modal {
  z-index: 400 !important;
}
/deep/.el-dialog__wrapper {
  z-index: 500 !important;
}
// 修改表格样式
/deep/.zk-table {
  margin-top: 20px;
  font-size: 16px;
}
/deep/.zk-table__body-row {
  height: 60px;
}
/deep/.zk-table__body-row:not(:first-of-type) {
  // border-top: none;
}
/deep/.zk-table__header-row {
  background-color: #40a0f2;
  line-height: 50px;
  font-size: 20px;
  color: #fff;
  .zk-table__header-cell {
    font-weight: normal;
  }
}
/deep/.zk-table--firstProp-header-inner {
  padding-left: 15px;
}
/deep/.zk-table {
  height: calc(100% - 85px);
  .zk-table__body-wrapper {
    height: calc(100% - 65px) !important;
    overflow-y: auto;
  }
}
</style>